import { render, staticRenderFns } from "./Star4half.vue?vue&type=template&id=2b1f6fdc&"
import script from "./Star4half.vue?vue&type=script&lang=js&"
export * from "./Star4half.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1f6fdc')) {
      api.createRecord('2b1f6fdc', component.options)
    } else {
      api.reload('2b1f6fdc', component.options)
    }
    module.hot.accept("./Star4half.vue?vue&type=template&id=2b1f6fdc&", function () {
      api.rerender('2b1f6fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Heading/stars/Star4half.vue"
export default component.exports